import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import products, { categories } from "./data/wholesaleProducts";
import Home from "./components/Home";
import Product from "./components/product";
import ProductDetail from "./components/Productdetail";
import Cart from "./components/Cart";
import Checkout from "./components/Checkout";
import Policy from "./components/Privacy";
import About from "./components/About";
import ContactUs from "./components/ContactUs";
import FooterBar from "./components/common/FooterBar";
const categorySlug = (x) => x.toLowerCase().replace(/\s+/g, "-");
export default function App() {
  const navigate = useNavigate(),
    location = useLocation(),
    path = location.pathname;
  const [sort, setSort] = useState("featured"),
    [finish, setFinish] = useState(products[0].sizes[0]),
    [navOpen, setNavOpen] = useState(false),
    [searchOpen, setSearchOpen] = useState(false),
    [query, setQuery] = useState("");
  const [cart, setCart] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("varsenic-cart") || localStorage.getItem("novair-cart") || "[]");
    } catch {
      return [];
    }
  });
  useEffect(
    () => localStorage.setItem("varsenic-cart", JSON.stringify(cart)),
    [cart],
  );
  const collectionMatch = path.match(/^\/collections\/([^/]+)$/),
    productMatch = path.match(/^\/products\/([^/]+)$/),
    policyMatch = path.match(/^\/policies\/([^/]+)$/),
    productSlug = productMatch?.[1] || "";
  const category = collectionMatch
    ? categories.find(
        (x) => categorySlug(x) === decodeURIComponent(collectionMatch[1]),
      ) || "All"
    : "All";
  const product = productMatch
    ? products.find((x) => x.slug === productMatch[1]) || products[0]
    : products[0];
  useEffect(() => {
    if (productSlug) setFinish(product.sizes[0]);
  }, [product.id, product.sizes, productSlug]);
  const closeMenus = () => {
      setNavOpen(false);
      setSearchOpen(false);
    },
    go = (url) => {
      closeMenus();
      navigate(url);
      window.scrollTo(0, 0);
    },
    shop = (cat = "All") => go(`/collections/${categorySlug(cat)}`),
    openProduct = (item) => go(`/products/${item.slug}`),
    openPolicy = (key) => go(`/policies/${key}`);
  const shown = useMemo(() => {
    let list = products.filter(
      (x) =>
        (category === "All" || x.category === category) &&
        `${x.title} ${x.category}`.toLowerCase().includes(query.toLowerCase()),
    );
    if (sort === "low") list = [...list].sort((a, b) => a.price - b.price);
    if (sort === "high") list = [...list].sort((a, b) => b.price - a.price);
    if (sort === "new") list = [...list].reverse();
    return list;
  }, [category, query, sort]);
  const add = () =>
    setCart((items) => {
      const key = `${product.id}-${finish}`,
        found = items.find((x) => x.key === key);
      return found
        ? items.map((x) => (x.key === key ? { ...x, qty: x.qty + 1 } : x))
        : [...items, { ...product, key, size: finish, qty: 1 }];
    });
  const count = cart.reduce((n, x) => n + x.qty, 0),
    subtotal = cart.reduce((n, x) => n + x.price * x.qty, 0),
    checkout = path === "/checkout";
  let content;
  if (path === "/") content = <Home shop={shop} openProduct={openProduct} />;
  else if (collectionMatch)
    content = (
      <Product
        items={shown}
        category={category}
        setCategory={shop}
        sort={sort}
        setSort={setSort}
        openProduct={openProduct}
      />
    );
  else if (productMatch)
    content = (
      <ProductDetail
        product={product}
        size={finish}
        setSize={setFinish}
        add={add}
        shop={shop}
        openProduct={openProduct}
      />
    );
  else if (path === "/cart")
    content = (
      <Cart
        items={cart}
        setCart={setCart}
        subtotal={subtotal}
        shop={shop}
        go={(route) =>
          go(
            route === "checkout"
              ? "/checkout"
              : route === "cart"
                ? "/cart"
                : "/",
          )
        }
      />
    );
  else if (path === "/checkout")
    content = (
      <Checkout
        items={cart.map((x) => ({ ...x, quantity: x.qty }))}
        onNavigate={(route) =>
          route === "shipping" || route === "returns"
            ? openPolicy(route)
            : go(route === "cart" ? "/cart" : "/")
        }
      />
    );
  else if (policyMatch)
    content = <Policy active={policyMatch[1]} openPolicy={openPolicy} />;
  else if (path === "/about") content = <About shop={shop} />;
  else if (path === "/support") content = <ContactUs openPolicy={openPolicy} />;
  else
    content = (
      <section className="not-found">
        <span>404</span>
        <h1>That page is out of range.</h1>
        <button className="primary-action" onClick={() => go("/")}>
          RETURN HOME →
        </button>
      </section>
    );
  return (
    <div className="site-shell">
      {!checkout && (
        <>
          <div className="top-note">
            Free standard delivery over $75 <span /> 30-day listening window
          </div>
          <header className="global-header">
            <button
              className="mobile-menu"
              onClick={() => setNavOpen(!navOpen)}
              aria-label="Menu"
            >
              {navOpen ? "×" : "☰"}
            </button>
            <button className="wordmark" onClick={() => go("/")} aria-label="VARSENIC home">
              <img src="/varsenic-logo.svg" alt="VARSENIC" />
            </button>
            <nav className={navOpen ? "open" : ""}>
              {categories.slice(1).map((x) => (
                <button key={x} onClick={() => shop(x)}>
                  {x}
                </button>
              ))}
              <button onClick={() => go("/about")}>Our approach</button>
            </nav>
            <div className="header-tools">
              <button onClick={() => setSearchOpen(!searchOpen)}>Search</button>
              <button onClick={() => go("/support")}>Support</button>
              <button className="bag-button" onClick={() => go("/cart")}>
                Bag <span>{count}</span>
              </button>
            </div>
            {searchOpen && (
              <form
                className="global-search"
                onSubmit={(e) => {
                  e.preventDefault();
                  shop("All");
                }}
              >
                <label>
                  SEARCH VARSENIC
                  <input
                    autoFocus
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="What are you looking for?"
                  />
                </label>
                <button>VIEW RESULTS</button>
              </form>
            )}
          </header>
        </>
      )}
      {content}
      {!checkout && (
        <FooterBar
          shop={shop}
          openPolicy={openPolicy}
          go={(route) =>
            go(
              route === "home"
                ? "/"
                : route === "about"
                  ? "/about"
                  : "/support",
            )
          }
        />
      )}
    </div>
  );
}
